import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { OrderService } from '../order.service'; // adjust the import path if needed
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderSubmittedGuard implements CanActivate {
  constructor(private orderService: OrderService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const orderId = route.paramMap.get('orderId');
    const isAdminView = route.queryParamMap.get('is_admin') === '1';

    return this.orderService.getOrder(orderId, "0").pipe(
      map(order => {
        if (order.bot_order.has_submitted_tab || order.bot_order.is_submitted) {
          if (isAdminView || order.bot_order.is_payment_pending) {
            return true;
          }
          // 🚨 Force reload the page when redirecting to success
          window.location.href = `/order/${orderId}/status/success`;
          return false; // Block navigation
        }
        return true; // Allow navigation if not submitted
      }),
      catchError(() => {
        // Optional: force reload to home or error page
        window.location.href = '/';
        return of(false);
      })
    );
  }
}
